export default "__VITE_ASSET__CHGra48w__"